import { MultipleSelectInstance, MultipleSelectOption, createDomElement, classNameToList, stripScripts } from "multiple-select-vanilla";
import icon from "src/decidim/ow_icon";
const OPTIONS_LIST_SELECTOR = ".ms-select-all, ul li[data-key]";
const OPTIONS_HIGHLIGHT_LIST_SELECTOR = ".ms-select-all.highlighted, ul li[data-key].highlighted";
export class ExtendedMultipleSelectInstance extends MultipleSelectInstance {
  /**
   * @param {HTMLElement} elm
   * @param {Partial<Omit<MultipleSelectOption, 'onHardDestroy' | 'onAfterHardDestroy'>>} options
   */
  constructor(elm, options) {
    super(elm, options);
  }
  initContainer() {
    super.initContainer();
    this.dropWrapperElm = createDomElement("div", { className: "ms-drop-wrapper" }, this.parentElm);
    this.dropWrapperElm.append(this.dropElm);
    const caretElement = this.choiceElm.querySelector(".ms-icon-caret");
    if (caretElement) {
      caretElement.remove();
      this.choiceElm.appendChild(icon("arrow-down", { class: "ms-icon ms-icon-caret" }));
    }
    const placeholderOptionElement = [...this.elm.options].find((option) => option.value === "");
    if (placeholderOptionElement) {
      this.options.placeholder = this.options.placeholder || placeholderOptionElement.getAttribute("data-placeholder") || placeholderOptionElement.innerText;
    }
    this.choiceElm.id = this.elm.id + "-trigger";
    const label = document.querySelector(`label[for="${this.elm.id}"]`);
    if (label) {
      label.setAttribute("for", this.choiceElm.id);
    }
    this.choiceElm.setAttribute("role", "combobox");
    this.choiceElm.setAttribute("aria-expanded", "false");
    this.choiceElm.setAttribute("aria-haspopup", "listbox");
  }
  /**
   *
   * @param {boolean} ignoreTrigger
   */
  update(ignoreTrigger = false) {
    var _a;
    const valueSelects = this.getSelects();
    let textSelects = this.getSelects("text");
    if (this.options.displayValues) {
      textSelects = valueSelects;
    }
    const spanElm = (_a = this.choiceElm) == null ? void 0 : _a.querySelector("span");
    const sl = valueSelects.filter((value) => !!value).length;
    let html = null;
    const getSelectOptionHtml = () => {
      if (this.options.useSelectOptionLabel || this.options.useSelectOptionLabelToHtml) {
        const labels = valueSelects.join(this.options.displayDelimiter);
        return this.options.useSelectOptionLabelToHtml ? stripScripts(labels) : labels;
      }
      const wrapOptionElement = (value) => {
        const optionWrapperElement = document.createElement("span");
        optionWrapperElement.classList.add("ms-option-wrapper");
        optionWrapperElement.innerText = value;
        return optionWrapperElement.outerHTML;
      };
      return textSelects.map(wrapOptionElement).join("");
    };
    if (spanElm) {
      spanElm.classList.toggle("ms-multiple-choices", this.elm.multiple && sl > 0 && sl <= this.options.minimumCountSelected && sl !== this.dataTotal);
      if (sl === 0) {
        const placeholder = this.options.placeholder || "";
        spanElm.classList.add("ms-placeholder");
        this.applyAsTextOrHtmlWhenEnabled(spanElm, placeholder);
      } else if (sl < this.options.minimumCountSelected) {
        html = getSelectOptionHtml();
      } else if (this.formatAllSelected() && sl === this.dataTotal) {
        html = this.formatAllSelected();
      } else if (this.options.ellipsis && sl > this.options.minimumCountSelected) {
        html = `${textSelects.slice(0, this.options.minimumCountSelected).join(this.options.displayDelimiter)}...`;
      } else if (this.formatCountSelected(sl, this.dataTotal) && sl > this.options.minimumCountSelected) {
        html = this.formatCountSelected(sl, this.dataTotal);
      } else {
        html = getSelectOptionHtml();
      }
      if (html !== null) {
        spanElm == null ? void 0 : spanElm.classList.remove("ms-placeholder");
        this.applyAsTextOrHtmlWhenEnabled(spanElm, html);
      }
      if (this.options.showClear && this.selectClearElm) {
        const displayState = html ? "block" : "none";
        this.selectClearElm.style.display = displayState;
      }
      if (this.options.displayTitle) {
        const selectType = this.options.useSelectOptionLabel || this.options.useSelectOptionLabelToHtml ? "value" : "text";
        spanElm.title = this.getSelects(selectType).join(
          this.options.displayDelimiter
        );
      }
    }
    const selectedValues = this.getSelects();
    if (this.options.single) {
      this.elm.value = selectedValues.length ? selectedValues[0] : "";
    } else {
      Array.from(this.elm.options).forEach((option) => {
        option.selected = selectedValues.some((val) => val === option.value);
      });
    }
    if (!ignoreTrigger) {
      this.elm.dispatchEvent(new Event("change"));
    }
  }
  initListItem(dataRow, level = 0) {
    const title = (dataRow == null ? void 0 : dataRow.title) || "";
    const multiple = this.options.multiple ? "multiple" : "";
    const type = this.options.single ? "radio" : "checkbox";
    const isChecked = !!(dataRow == null ? void 0 : dataRow.selected);
    const isSingleWithoutRadioIcon = this.options.single && !this.options.singleRadio;
    let classes = "";
    if (!(dataRow == null ? void 0 : dataRow.visible)) {
      return [];
    }
    this.updateData.push(dataRow);
    if (isSingleWithoutRadioIcon) {
      classes = "hide-radio ";
    }
    if (dataRow.selected) {
      classes += "selected ";
    }
    if (dataRow.type === "optgroup") {
      const htmlBlocks = [];
      let itemOrGroupBlock;
      if (this.options.hideOptgroupCheckboxes || this.options.single) {
        itemOrGroupBlock = {
          tagName: "span",
          props: { dataset: { name: this.selectGroupName, key: dataRow._key } }
        };
      } else {
        const inputCheckboxStruct = {
          tagName: "input",
          props: {
            type: "checkbox",
            dataset: { name: this.selectGroupName, key: dataRow._key },
            checked: isChecked,
            disabled: dataRow.disabled
          }
        };
        if (isSingleWithoutRadioIcon) {
          itemOrGroupBlock = inputCheckboxStruct;
        } else {
          itemOrGroupBlock = {
            tagName: "div",
            props: {
              className: `icon-checkbox-container${type === "radio" ? " radio" : ""}`
            },
            children: [
              inputCheckboxStruct
            ]
          };
        }
      }
      if (!classes.includes("hide-radio") && (this.options.hideOptgroupCheckboxes || this.options.single)) {
        classes += "hide-radio ";
      }
      const spanLabelBlock2 = { tagName: "span", props: {} };
      this.applyAsTextOrHtmlWhenEnabled(spanLabelBlock2.props, dataRow.label);
      const liBlock2 = {
        tagName: "li",
        props: {
          className: classNameToList(
            `group${this.options.single || dataRow.disabled ? " disabled" : ""} ${classes}`
          ).join(" "),
          role: "option",
          ariaSelected: String(isChecked),
          dataset: { key: dataRow._key }
        },
        children: [
          {
            tagName: "label",
            props: {
              className: classNameToList(
                `optgroup${this.options.single || dataRow.disabled ? " disabled" : ""}`
              ).join(" ")
            },
            children: [itemOrGroupBlock, spanLabelBlock2]
          }
        ]
      };
      const customStyleRules2 = this.options.cssStyler(dataRow);
      if (customStyleRules2) {
        liBlock2.props.style = customStyleRules2;
      }
      htmlBlocks.push(liBlock2);
      dataRow.children.forEach(
        (child) => htmlBlocks.push(...this.initListItem(child, 1))
      );
      return htmlBlocks;
    }
    classes += dataRow.classes || "";
    if (level && this.options.single) {
      classes += `option-level-${level} `;
    }
    if (dataRow.divider) {
      return [{ tagName: "li", props: { className: "option-divider" } }];
    }
    let liClasses = multiple || classes ? (multiple + classes).trim() : "";
    if (dataRow.disabled) {
      liClasses += " disabled";
    }
    const labelClasses = `${dataRow.disabled ? "disabled" : ""}`;
    const spanLabelBlock = { tagName: "span", props: {} };
    this.applyAsTextOrHtmlWhenEnabled(spanLabelBlock.props, dataRow.text);
    const inputBlock = {
      tagName: "input",
      props: {
        type,
        value: encodeURI(dataRow.value),
        dataset: { key: dataRow._key, name: this.selectItemName },
        checked: isChecked,
        disabled: !!dataRow.disabled
      }
    };
    if (dataRow.selected) {
      inputBlock.attrs = { checked: "checked" };
    }
    const iconContainerBlock = {
      tagName: "div",
      props: {
        className: `icon-checkbox-container${type === "radio" ? " radio" : ""}`
      },
      children: [
        inputBlock
      ]
    };
    const liBlock = {
      tagName: "li",
      props: {
        role: "option",
        title,
        ariaSelected: String(isChecked),
        dataset: { key: dataRow._key }
      },
      children: [
        {
          tagName: "label",
          props: { className: labelClasses },
          children: [
            // add icon container when showing radio OR using multiple select
            isSingleWithoutRadioIcon ? inputBlock : iconContainerBlock,
            spanLabelBlock
          ]
        }
      ]
    };
    if (liClasses) {
      liBlock.props.className = liClasses;
    }
    const customStyleRules = this.options.cssStyler(dataRow);
    if (customStyleRules) {
      liBlock.props.style = customStyleRules;
    }
    return [liBlock];
  }
  initList(renderFilterAndSearchAll = true) {
    this.options.filterPlaceholder = this.options.filterPlaceholder || this.options.formatFilterPlaceholder();
    super.initList(renderFilterAndSearchAll);
    this.ulElm.setAttribute("id", this.elm.id + "-listbox");
    this.choiceElm.setAttribute("aria-controls", this.ulElm.id);
    if (this.selectAllParentElm) {
      const defaultCheckboxIconElement = this.selectAllParentElm.querySelector(".ms-icon");
      if (defaultCheckboxIconElement) {
        defaultCheckboxIconElement.replaceWith(icon("checkbox-checked"));
      }
    }
    if (this.elm.multiple) {
      this.ulElm.childNodes.forEach((element) => {
        this.fixIconCheckboxContainer(element);
        const iconCheckboxContainer = element.querySelector(".icon-checkbox-container");
        if (iconCheckboxContainer) {
          iconCheckboxContainer.append(icon("checkbox-checked"));
        }
      });
      this.fixIconCheckboxContainer(this.selectAllParentElm);
    }
  }
  fixIconCheckboxContainer(rootElement) {
    if (!rootElement) {
      return;
    }
    const currentIconCheckboxContainer = rootElement.querySelector(".icon-checkbox-container");
    if (!currentIconCheckboxContainer) {
      return;
    }
    const newIconCheckboxContainer = createDomElement("span", { className: "icon-checkbox-container" });
    const parentElement = currentIconCheckboxContainer.parentElement;
    newIconCheckboxContainer.append(...currentIconCheckboxContainer.children);
    parentElement.insertBefore(newIconCheckboxContainer, parentElement.lastChild);
    currentIconCheckboxContainer.remove();
  }
  /**
   * @protected
   */
  highlightCurrentOption() {
    super.highlightCurrentOption();
    if (!this.dropElm) {
      return;
    }
    const optionElms = this.dropElm.querySelectorAll(OPTIONS_LIST_SELECTOR) || [];
    if (this._currentHighlightIndex <= optionElms.length) {
      const currentOption = optionElms[this._currentHighlightIndex];
      if (currentOption) {
        currentOption.setAttribute("tabindex", "0");
        currentOption.focus();
      }
    }
  }
  /**
   * @protected
   * @param optionElm
   */
  changeCurrentOptionHighlight(optionElm) {
    var _a;
    super.changeCurrentOptionHighlight(optionElm);
    if (!optionElm || !this.dropElm) {
      return;
    }
    const currentElms = ((_a = this.dropElm) == null ? void 0 : _a.querySelectorAll(OPTIONS_HIGHLIGHT_LIST_SELECTOR)) || [];
    currentElms.forEach((option) => {
      if (option !== optionElm) {
        option.classList.remove("highlighted");
        option.setAttribute("tabindex", "-1");
      }
    });
  }
  /**
   * @protected
   */
  openDrop() {
    super.openDrop();
    this.choiceElm.setAttribute("aria-expanded", "true");
  }
  /**
   * @protected
   * @param reason
   */
  close(reason = null) {
    super.close(reason);
    this.choiceElm.setAttribute("aria-expanded", "false");
  }
}
